module.exports = __webpack_public_path__ + "media/images/backgrounds/blog-header-image-084676303e843ce477db054703cc79fb.png";